<script>
import { mapActions, mapState } from "vuex";

import formatterDocumentId from "@/utils/formatters/documentId";

import InputGroup from "@/components/_Shared/InputGroup";

export default {
  components: {
    InputGroup
  },

  methods: {
    ...mapActions("orderCancellation", ["updateRefund"])
  },

  computed: {
    ...mapState("orderCancellation", ["order", "refund"]),

    document: function() {
      return formatterDocumentId.document(this.order.customer);
    }
  }
};
</script>

<template>
  <div class="refund">
    <div class="text">
      Para agilizar o reembolso do seu pedido, como o pagamento foi feito via boleto bancário, precisamos dos dados de uma conta bancária vinculado ao documento:
      <br />
      <br />
      <b>{{ document }}</b>
    </div>

    <div class="refund-info">
      <div>
        <InputGroup
          :error="errors.first('nome do banco')"
          v-validate="'required'"
          :value="refund.bank"
          name="bank"
          label="nome do banco"
          @input="(value) => updateRefund({ bank: value })"
        />
      </div>

      <div>
        <InputGroup
          :error="errors.first('agência')"
          v-validate="'required'"
          :value="refund.agency"
          name="agency"
          label="agência"
          @input="(value) => updateRefund({ agency: value })"
        />

        <InputGroup
          :error="errors.first('número da conta com dígito')"
          v-validate="'required'"
          :value="refund.account"
          name="accountNumberWithDigit"
          label="número da conta com dígito"
          @input="(value) => updateRefund({ account: value })"
        />
      </div>

      <div>
        <InputGroup
          :error="errors.first('tipo da conta')"
          type="select"
          v-validate="'required'"
          :value="refund.accountType"
          name="accountType"
          label="Tipo da conta"
          @input="(value) => updateRefund({ accountType: value })"
        >
          <template slot="options">
            <option value="Conta corrente">Conta Corrente</option>
            <option value="Conta poupança">Conta Poupança</option>
            <option value="Outro">Outro</option>
          </template>
        </InputGroup>
      </div>
    </div>
  </div>
</template>

<style scoped>
.text {
  color: #424242;
  font-size: 14px;
  width: 100%;
  text-align: center;
}

.refund-info {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.refund-info > div {
  display: flex;
  flex-direction: column;
}

@media (min-width: 768px) {
  .refund-info > div {
    flex-direction: row;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Components/Actions/Cancellation/CancellationRefund.vue